// sélecteurs isolés pour le state 'vital' (reducer key)
export const selectVitalSignals = (state) => state.vital?.signals ?? [];
export const selectVitalLoading = (state) => Boolean(state.vital?.loading);
export const selectVitalError   = (state) => state.vital?.error ?? null;
